// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";
import AgentRunDetail from "./AgentRunDetail";

// icons
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TableViewIcon from "@mui/icons-material/TableView";



class AgentRunEntityCreate extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            button: this.props.button || {
                icon: AutoAwesomeIcon,
                label: this.props.agent.short_title,
                color: 'purple',
            },
            ready: true,
            flat: true,
        })
    }

    async beforeModalOpen(){
        let formFields = [
            {
                name: 'prompt',
                label: 'Промпт',
                xs: 12,
                sm: null,
                md: null,
                lg: null,
                xl: null,
                required: true,
                default: this.props.agent.run_variables.prompt?.default,
                type: 'textarea',
            },
            {
                type: 'submit',
                label: 'Далее',
            },
        ]
        return {
            modalLabel: `Запуск агента ${this.props.agent.title}`,
            modalIcon: TableViewIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
        }
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        let url = `agent_run/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            {
                agent: this.props.agent.id
            }
        );
        let agent_run = response.data
        if (response.status === 201) {
            url += agent_run.id.toString() + '/'
            let run_variables = {}
            run_variables[this.props.entity.toLowerCase()] = this.props.entityId
            run_variables.prompt = formDataObj.prompt
            response = await api.patch(
                url,
                {
                    run_variables: run_variables
                }
            );
            if (response.status === 200) {
                url += 'process/'
                response = await api.get(
                    url,
                    {}
                );

                this.setState({
                    mainComponent: AgentRunDetail,
                    mainComponentProps: {
                        params: {
                            agentRunId: agent_run.id
                        }
                    },
                    size: 'sm',
                    width: 'calc(80vw)',
                    height: 'calc(80vh)'
                })
            }
        }
    }

    async beforeModalClose(){
        // await this.props.callBack();
    }
}

export default AgentRunEntityCreate
